import objectFitImages from 'object-fit-images';

const $ = window.jQuery;

$(() => {
    const $location_link = $(
        '.single-content__sidebar-item--location .single-content__sidebar-item-text',
    );

    if (!$location_link.length) {
        return;
    }

    $location_link.on('click', () => {
        const $location = $('#location');
        if ($location.length) {
            const location_top = $location.offset().top;
            $('html,body').animate({ scrollTop: location_top - 150 }, 300);
        }
    });

    objectFitImages('.event-hero__img__src');
});
